import React, { useEffect, useState } from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import "../../rules-regulations.css";
import API_URL from "../../config/constant";

const FRONTLINER_NAMES = [
    // Males
    { name: "NOFINDRA", isFemale: false },
    { name: "AHYANI", isFemale: false },
    { name: "ANDREWSTYAMA HATOMONO", isFemale: false },
    { name: "M. AKSEL PRATAMA", isFemale: false },
    { name: "GALANG BAGUS PRATAMA", isFemale: false },
    { name: "M GUNTUR PRASTIO", isFemale: false },
    { name: "MOCHAMAD NOVALIANDI", isFemale: false },
    { name: "FATIH ABDUL AZIZ", isFemale: false },
    { name: "SARDANA", isFemale: false },
    { name: "MISBAKHUL ANAM", isFemale: false },
    { name: "MERDI SUSANTO", isFemale: false },
    { name: "FAHRI HAIDAR", isFemale: false },
    { name: "DANI HIDAYAT", isFemale: false },
    { name: "HENDRI", isFemale: false },
    { name: "STERENLIE", isFemale: false },
    { name: "HARTOYO", isFemale: false },
    { name: "AGHA AISY", isFemale: false },
    { name: "BAKTIAR MUNTHE", isFemale: false },
    { name: "GENTA PUTRA", isFemale: false },
    { name: "SEBASTIAN PUTRA RIZQY PRATAMA", isFemale: false },
    { name: "JASON LAMHOT DOLI TAMBUNAN", isFemale: false },
    { name: "RIFQI ENNO SAPUTRA", isFemale: false },
    { name: "IKHWAN KURNIAWAN", isFemale: false },
    { name: "ISEP RAMDAN", isFemale: false },
    { name: "MUHAMMAD NUR RASYID", isFemale: false },
    { name: "ERIK SEMBIRING", isFemale: false },

    // Females
    { name: "GINA FITRIANI", isFemale: true },
    { name: "MAURIN KIRANA LARASATI", isFemale: true },
    { name: "PATRICIA ANGEL", isFemale: true },
    { name: "ARUMI FAJRIANI AZHAR", isFemale: true },
    { name: "NI MADE NARISA NARESWARI PRANANDARI", isFemale: true },
    { name: "VIRGINIA CESYA UTUWALY", isFemale: true },
    { name: "ELISABET PASARIBU", isFemale: true },
    { name: "ANGELIA PO", isFemale: true },
    { name: "ALLESIA EUREKA", isFemale: true },
    { name: "ADIAWARDAYANI", isFemale: true },
    { name: "TETTY PAY DEN FRANSISCA H", isFemale: true },
    { name: "HANA NATHASYA", isFemale: true },
    { name: "IRMA AYU PRAMUDIKA", isFemale: true },
    { name: "HENNY SETYAWATI", isFemale: true },
    { name: "NAOMI SIMARMATA", isFemale: true },
    { name: "EVI OCFRIDAYANTI P", isFemale: true },
    { name: "BULAN", isFemale: true },
    { name: "MARIA GOLDIANA TAPING", isFemale: true },
    { name: "LINDA WULANDARI", isFemale: true },
    { name: "NURFITRIANA", isFemale: true },
    { name: "LYUTASYA KHOWILYA TEOH", isFemale: true },
    { name: "SHELOMITHA", isFemale: true },
    { name: "WESTYAS SAYKITA PUTRI", isFemale: true },
    { name: "NIKYA MAILANGKAY", isFemale: true },
    { name: "DANTY AMALYA", isFemale: true },
];

export default function Frontliner() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);

    useEffect(() => {
        const fetchAboutData = async () => {
            let baseData = [];
            try {
                const response = await fetch(`${API_URL}/frontliner?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res && res.length >= 1) {
                    baseData = res;
                } else {
                    baseData = t("frontliner.content", { returnObjects: true }) || [];
                }
            } catch (error) {
                baseData = t("frontliner.content", { returnObjects: true }) || [];
            }

            // Check if tab already exists, if so mark it, otherwise append
            const tabTitle = "THE 50 FRONTLINERS 2026";
            const exists = baseData.some(tab => tab.title === tabTitle);
            if (exists) {
                baseData = baseData.map(tab =>
                    tab.title === tabTitle ? { ...tab, isCustomSelectedList: true } : tab
                );
            } else {
                baseData.push({
                    title: tabTitle,
                    isCustomSelectedList: true,
                    data: []
                });
            }
            setData(baseData);
        };

        fetchAboutData();
    }, [t, locale]);

    return (
        <div className="text-white md:px-0 px-4 bg-white 2xl:pb-96 lg:pb-96 md:pb-80 pb-40">
            <div className="relative h-[240px] md:h-[300px] bg-brand-blue bg-cover bg-no-repeat flex justify-center items-center mt-[86px] md:mt-[109px] 2xl:mt-[136px]">
                <PageHeadline title={t('frontliner.title')} />
            </div>
            <div className="relative top-12 md:top-20 lg:top-32 bg-white 2xl:px-0 md:px-14 px-0">
                <div className="bg-white min-h-screen container mx-auto px-4 w-full font-poppins text-brand-blue">
                    <div className="flex md:flex-row flex-col gap-x-24 mt-10">
                        <div className="flex flex-col md:gap-y-10 gap-y-5 mb-10">
                            {data?.map((parent, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentIndex(index)}
                                    className={`uppercase text-start w-52 text-lg ${currentIndex === index
                                        ? "text-brand-blue border-b border-b-brand-blue font-bold"
                                        : "text-neutral-500 font-normal border-none"
                                        }`}
                                >
                                    {parent.title}
                                </button>
                            ))}
                        </div>
                        {data && data[currentIndex]?.isCustomSelectedList ? (
                            <div className="w-full pb-20 max-md:px-4">
                                <div className="overflow-hidden">
                                    <div className="-ml-6 leading-loose flex flex-wrap text-left">
                                        {FRONTLINER_NAMES.map((item, index) => (
                                            <span key={index} className="inline-block whitespace-nowrap">
                                                <span className="text-neutral-300 w-6 inline-block text-center select-none">•</span>
                                                <span
                                                    className={`font-evil tracking-wider transition-transform duration-200 hover:scale-[1.08] inline-block text-sm md:text-base cursor-default py-1 ${item.isFemale ? "text-brand-orange" : "text-brand-blue"
                                                        }`}
                                                >
                                                    {item.name}
                                                </span>
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : currentIndex === 0 || currentIndex === 1 ? (
                            <div className="rich-text font-light leading-loose max-md:px-4 flex flex-col gap-y-4">
                                {data && data[currentIndex]?.data && data[currentIndex].data.map((text, key) => (
                                    <div className="text-justify" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></div>
                                ))}
                            </div>
                        ) : (
                            <div className="rich-text">
                                <ol className="font-light list-decimal leading-loose max-md:px-4">
                                    {data && data[currentIndex]?.data && data[currentIndex].data.map((text, key) => (
                                        <li className="text-justify" key={key} dangerouslySetInnerHTML={{ __html: text.desc }}></li>
                                    ))}
                                </ol>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
